<template>
  <div class="week-container">
    <tool-bar
      v-model:selectedWeek="selectedWeek"
      v-model:allOrCurrent="allOrCurrent"
      :user-id="userId"
      :okr-id="okrId"
    />
    <my-table
      :table-id="tableId"
      :columns="columns"
      :data="data"
      :loading="loading"
    >
      <template #bodyCell="{ text, column, record }">
        <template v-if="column.indexOf('week') >= 0">
          <div class="content">
            <div v-html="parseContent(column, record)" />
            <div
              v-if="commentVisible(record, column)"
              class="comment-button"
              @click.stop="editCommentHandler(record, column)"
            >
              {{ t('weekly.checkComment') }}
            </div>
            <div
              v-if="canEditRisk(record, column)"
              class="comment-button"
              @click.stop="editRiskHandler(record, column)"
            >
              {{ t('weekly.edit') }}
            </div>
          </div>
        </template>
        <template v-else-if="column === 'childKrProgress'">
          <span v-if="'childKrProgress' in record">{{ text }}%</span>
          <span v-else>-</span>
        </template>
        <template v-else>
          <div v-html="text" />
        </template>
      </template>
    </my-table>
    <edit-comment
      v-model:visible="editCommentVisible"
      :weekly-detail="weeklyDetail"
    />
    <edit-risk
      v-model:visible="editRiskVisible"
      :week-data="weekData"
      :update-week-risk="updateWeekRisk"
    />
  </div>
</template>
<script setup>
import ToolBar from './ToolBar.vue'
import MyTable from '@/components/MyTable/index'
import useOkr from './useOkr'
import useTable from './useTable.js'
import useTime from './useTime.js'
import EditComment from '@/views/OkrWeek/EditComment/index.vue'
import EditRisk from './EditRisk'
import { computed, toRefs, ref } from 'vue'
import { useStore } from 'vuex'
import { replaceStr2Html } from '@/utils/line-break'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  userId: {
    type: [Number, String],
    default: undefined
  }
})
const { userId } = toRefs(props)

const { selectedWeek } = useTime()

const allOrCurrent = ref('ALL')
const { data, loading, okrId } = useOkr(props, selectedWeek, allOrCurrent)

const { columns } = useTable(selectedWeek)

// 生成tableId
const store = useStore()
const tableId = computed(() => {
  const user = userId.value || 'self'
  const year = (store.state.yearCycles[store.state.activeYearIndex] || [])[0]?.name
  return `myteam-${user}-${year}`
})

// 是否可以查看评论
const commentVisible = (item, column) => {
  const week = column.split(':')[1]
  return column.indexOf('remarks') >= 0 && item.week && item.week[week]
}

const canEditRisk = (item, column) => {
  const week = column.split(':')[1]
  return column.indexOf('currentRiskToEdit') >= 0 && item.week && item.week[week] && item.week[week].currentRiskToEdit
}

// 编辑风险
const editRiskVisible = ref(false)
const updateWeekRisk = ref(undefined)
const weekData = ref(undefined)
const editRiskHandler = (item, column) => {
  const week = column.split(':')[1]
  weekData.value = item.week[week] || {
    objectiveId: item.objectiveId,
    keyresultId: item.krId,
    okrlistId: okrId.value,
    weekDate: week
  }
  updateWeekRisk.value = (val) => {
    console.log(val)
    item.week[week].currentRiskToEdit = val
  }
  editRiskVisible.value = true
}

// 编辑评论
const editCommentVisible = ref(false)
const weeklyDetail = ref(undefined)
const editCommentHandler = (record, column) => {
  const week = column.split(':')[1]
  weeklyDetail.value = record.week[week]
  editCommentVisible.value = true
}

// get content
const parseContent = (column, record) => {
  return replaceStr2Html((column.split(':').reduce((pre, cur) => pre[cur] || '-', record)) || '')
}

</script>
<style lang="less" scoped>
.comment-button {
  color: #0085FF;
  cursor: pointer;
}
</style>
